import { Datepicker } from "flowbite-react";

interface CustomDatepickerProps {
  selectedDate: Date | undefined;
  minDate?: Date;
  maxDate?: Date;
  labelTodayButton?: string;
  labelClearButton?: string;
  placeholder?: string;
  onDateChange: (date: Date) => void;
  disabled?: boolean;
}

export const CustomDatepicker: React.FC<CustomDatepickerProps> = ({
  selectedDate,
  minDate,
  maxDate,
  labelTodayButton = "오늘",
  labelClearButton = "취소하기",
  placeholder = "일자 선택",
  onDateChange,
  disabled = false,
}) => {
  return (
    <Datepicker
      language="ko"
      weekStart={1}
      labelTodayButton={labelTodayButton}
      labelClearButton={labelClearButton}
      value={selectedDate || undefined}
      minDate={minDate}
      maxDate={maxDate}
      onChange={(date) => date && onDateChange(date)}
      disabled={disabled}
    />
  );
};
